import { Action } from '@ngrx/store';
import { IAdmin } from 'src/commons';

export enum AdminActionTypes {
  LoadAdminState = '[Admin] Load Admin State',
  LoadAdminStateSuccess = '[Admin] Load Admin State Success',
  LoadAdminStateFail = '[Admin] Load Admin State Fail',
  AdminScreenErrorReset = '[Admin] Admin Screen Error Reset'

}

export class LoadAdminState implements Action {
  readonly type = AdminActionTypes.LoadAdminState;
}

export class LoadAdminStateSuccess implements Action {
  readonly type = AdminActionTypes.LoadAdminStateSuccess;
  constructor(public payload: IAdmin ) {}
}

export class LoadAdminStateFail implements Action {
  readonly type = AdminActionTypes.LoadAdminStateFail;
  constructor(public payload: any) {}
}

export class AdminScreenErrorReset implements Action {
  readonly type = AdminActionTypes.AdminScreenErrorReset;
}

export type AdminActions = 
  LoadAdminState
  | LoadAdminStateSuccess
  | LoadAdminStateFail
  | AdminScreenErrorReset;